// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_isJmT {
  z-index: 999;
  position: absolute;
}
.bg_q1X6m {
  background-color: var(--_00000033-shadow);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}

.importContainer_se1pL {
  background-color: var(--f5-background);
  z-index: 9999;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  animation: scaleUp_D0WlX 300ms ease-out forwards;
  -webkit-animation: scaleUp_D0WlX 300ms ease-out forwards;
  overflow: hidden;
  @media (width<768px) {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
  h2 {
    margin: 0;
    font-weight: 400;
    font-size: 25px;
  }
  p {
    margin: 0;
    color: var(--_10a37f-background);
    font-weight: bold;
  }
  header {
    gap: 10px;
  }
}
.importContent_aceL_ {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
  @media (width<768px) {
    height: calc(100% - 74px);
    justify-content: center;
  }
  .descText_Ga07O {
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    color: var(--_71717a-color);
    span{
      font-weight: 400;
    }
  }
}
.dropZoneContainer_JrZ0F {
  padding: 5px;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--white-color);
}
.dropZone_ivMxB {
  border: 2px dashed #ccc;
  padding: 30px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  margin: 20px;
}

.uploadButton_MQth2 {
  background-color: transparent;
  color: #2ebc89;
  padding: 10px 20px;
  border: 1px solid #2ebc89;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
}

.hiddenInput_s9hFo {
  display: none;
}

.dragging_keVKE {
  border-color: #2ebc89;
}
.scaleDown_vwaM5 {
  animation: scaleDown_vwaM5 300ms ease-in forwards;
  -webkit-animation: scaleDown_vwaM5 300ms ease-in forwards;
}

@keyframes scaleUp_D0WlX {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_vwaM5 {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_rxFvW {
  opacity: 0;
}
.tableDataFiles_kfL6i {
  width: 100%;
  overflow: auto;
  max-height: 200px;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  scrollbar-width: none;

  th {
    font-size: 13px;
  }
}

.infoFile_LStMa {
  border-left: 10px solid var(--_10a37f-background);
  padding-left: 12px;
  border-radius: 5px 0 0 5px;
  -webkit-border-radius: 5px 0 0 5px;
  -moz-border-radius: 5px 0 0 5px;
  -ms-border-radius: 5px 0 0 5px;
  -o-border-radius: 5px 0 0 5px;

  .fileInfoName_iew3f{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    box-sizing: border-box;
    >div{
      display: flex;
      align-items: center;
      gap: 10px;
      color: #666666;
      font-size: 13px;
    }
  }
  span {
    color: var(--_71717a-color);
    font-size: 13px;
  }
  p {
    color: #292a2b;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ImportContactsAndProducts/ImportContactsAndProducts.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gDAA0C;EAC1C,wDAAkD;EAClD,gBAAgB;EAChB;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,SAAS;IACT,gCAAgC;IAChC,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf;IACE,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B;MACE,gBAAgB;IAClB;EACF;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;;EAEjB;IACE,UAAU;IACV,WAAW;EACb;;EAEA,qBAAqB;;EAErB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;;EAE7B;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,eAAe;IACjB;EACF;EACA;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".overlay {\n  z-index: 999;\n  position: absolute;\n}\n.bg {\n  background-color: var(--_00000033-shadow);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.importContainer {\n  background-color: var(--f5-background);\n  z-index: 9999;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 100%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  overflow: hidden;\n  @media (width<768px) {\n    height: 100vh;\n    width: 100vw;\n    max-width: 100vw;\n  }\n  h2 {\n    margin: 0;\n    font-weight: 400;\n    font-size: 25px;\n  }\n  p {\n    margin: 0;\n    color: var(--_10a37f-background);\n    font-weight: bold;\n  }\n  header {\n    gap: 10px;\n  }\n}\n.importContent {\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0;\n  @media (width<768px) {\n    height: calc(100% - 74px);\n    justify-content: center;\n  }\n  .descText {\n    font-size: 14px;\n    text-align: center;\n    cursor: pointer;\n    color: var(--_71717a-color);\n    span{\n      font-weight: 400;\n    }\n  }\n}\n.dropZoneContainer {\n  padding: 5px;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: var(--white-color);\n}\n.dropZone {\n  border: 2px dashed #ccc;\n  padding: 30px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: center;\n  margin: 20px;\n}\n\n.uploadButton {\n  background-color: transparent;\n  color: #2ebc89;\n  padding: 10px 20px;\n  border: 1px solid #2ebc89;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.hiddenInput {\n  display: none;\n}\n\n.dragging {\n  border-color: #2ebc89;\n}\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n.tableDataFiles {\n  width: 100%;\n  overflow: auto;\n  max-height: 200px;\n\n  &::-webkit-scrollbar {\n    width: 0px;\n    height: 0px;\n  }\n\n  scrollbar-width: none;\n\n  th {\n    font-size: 13px;\n  }\n}\n\n.infoFile {\n  border-left: 10px solid var(--_10a37f-background);\n  padding-left: 12px;\n  border-radius: 5px 0 0 5px;\n  -webkit-border-radius: 5px 0 0 5px;\n  -moz-border-radius: 5px 0 0 5px;\n  -ms-border-radius: 5px 0 0 5px;\n  -o-border-radius: 5px 0 0 5px;\n\n  .fileInfoName{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n    box-sizing: border-box;\n    >div{\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: #666666;\n      font-size: 13px;\n    }\n  }\n  span {\n    color: var(--_71717a-color);\n    font-size: 13px;\n  }\n  p {\n    color: #292a2b;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_isJmT`,
	"bg": `bg_q1X6m`,
	"importContainer": `importContainer_se1pL`,
	"scaleUp": `scaleUp_D0WlX`,
	"importContent": `importContent_aceL_`,
	"descText": `descText_Ga07O`,
	"dropZoneContainer": `dropZoneContainer_JrZ0F`,
	"dropZone": `dropZone_ivMxB`,
	"uploadButton": `uploadButton_MQth2`,
	"hiddenInput": `hiddenInput_s9hFo`,
	"dragging": `dragging_keVKE`,
	"scaleDown": `scaleDown_vwaM5`,
	"fadeOut": `fadeOut_rxFvW`,
	"tableDataFiles": `tableDataFiles_kfL6i`,
	"infoFile": `infoFile_LStMa`,
	"fileInfoName": `fileInfoName_iew3f`
};
export default ___CSS_LOADER_EXPORT___;
